import { Path, Svg } from "react-native-svg";
import { createIcon } from "../factories/createIcon";
export const [ArrowChange, AnimatedArrowChange] = createIcon({
  name: "ArrowChange",
  getIcon: (props) => <Svg viewBox="0 0 24 24" fill="none" {...props}><Path
    d="M10.6979 16.2453L6.31787 9.75247C5.58184 8.66118 6.2058 7 7.35185 7L16.6482 7C17.7942 7 18.4182 8.66243 17.6821 9.75247L13.3021 16.2453C12.623 17.2516 11.377 17.2516 10.6979 16.2453Z"
    fill="currentColor"
  /></Svg>
});
